var _excluded = ["enum"];

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import MaskedPattern from "./pattern.js";
import IMask from "../core/holder.js";
import ChangeDetails from "../core/change-details.js";
import { DIRECTION } from "../core/utils.js";
import ContinuousTailDetails from "../core/continuous-tail-details.js";
import "./base.js";
import "./factory.js";
import "./pattern/chunk-tail-details.js";
import "./pattern/cursor.js";
import "./pattern/fixed-definition.js";
import "./pattern/input-definition.js";
import "./regexp.js";
/** Pattern which validates enum values */

var MaskedEnum =
/*#__PURE__*/
function (_MaskedPattern) {
  _inherits(MaskedEnum, _MaskedPattern);

  function MaskedEnum(opts) {
    _classCallCheck(this, MaskedEnum);

    return _possibleConstructorReturn(this, _getPrototypeOf(MaskedEnum).call(this, _objectSpread2(_objectSpread2({}, MaskedEnum.DEFAULTS), opts))); // mask will be created in _update
  }

  _createClass(MaskedEnum, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedEnum.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var enum_ = opts["enum"],
          eopts = _objectWithoutProperties(opts, _excluded);

      if (enum_) {
        var lengths = enum_.map(function (e) {
          return e.length;
        });
        var requiredLength = Math.min.apply(Math, _toConsumableArray(lengths));
        var optionalLength = Math.max.apply(Math, _toConsumableArray(lengths)) - requiredLength;
        eopts.mask = '*'.repeat(requiredLength);
        if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
        this["enum"] = enum_;
      }

      _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, eopts);
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      var _this = this;

      if (flags === void 0) {
        flags = {};
      }

      var matchFrom = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
      var matches = this["enum"].filter(function (e) {
        return _this.matchValue(e, _this.unmaskedValue + ch, matchFrom);
      });

      if (matches.length) {
        if (matches.length === 1) {
          this._forEachBlocksInRange(0, this.value.length, function (b, bi) {
            var mch = matches[0][bi];
            if (bi >= _this.value.length || mch === b.value) return;
            b.reset();

            b._appendChar(mch, flags);
          });
        }

        var d = _get(_getPrototypeOf(MaskedEnum.prototype), "_appendCharRaw", this).call(this, matches[0][this.value.length], flags);

        if (matches.length === 1) {
          matches[0].slice(this.unmaskedValue.length).split('').forEach(function (mch) {
            return d.aggregate(_get(_getPrototypeOf(MaskedEnum.prototype), "_appendCharRaw", _this).call(_this, mch));
          });
        }

        return d;
      }

      return new ChangeDetails({
        skip: !this.isComplete
      });
    }
  }, {
    key: "extractTail",
    value: function extractTail(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }

      if (toPos === void 0) {
        toPos = this.displayValue.length;
      } // just drop tail


      return new ContinuousTailDetails('', fromPos);
    }
  }, {
    key: "remove",
    value: function remove(fromPos, toPos) {
      var _this2 = this;

      if (fromPos === void 0) {
        fromPos = 0;
      }

      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }

      if (fromPos === toPos) return new ChangeDetails();
      var matchFrom = Math.min(_get(_getPrototypeOf(MaskedEnum.prototype), "nearestInputPos", this).call(this, 0, DIRECTION.FORCE_RIGHT), this.value.length);
      var pos;

      for (pos = fromPos; pos >= 0; --pos) {
        var matches = this["enum"].filter(function (e) {
          return _this2.matchValue(e, _this2.value.slice(matchFrom, pos), matchFrom);
        });
        if (matches.length > 1) break;
      }

      var details = _get(_getPrototypeOf(MaskedEnum.prototype), "remove", this).call(this, pos, toPos);

      details.tailShift += pos - fromPos;
      return details;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this["enum"].indexOf(this.value) >= 0;
    }
  }]);

  return MaskedEnum;
}(MaskedPattern);
/** Match enum value */


MaskedEnum.DEFAULTS = _objectSpread2(_objectSpread2({}, MaskedPattern.DEFAULTS), {}, {
  matchValue: function matchValue(estr, istr, matchFrom) {
    return estr.indexOf(istr, matchFrom) === matchFrom;
  }
});
IMask.MaskedEnum = MaskedEnum;
export { MaskedEnum as default };